import type { AmazonSalesResponse } from "reedy-data/api";
import type { Granularity } from "~/components/charts";
import { useSalesQuery } from "./use-sales-query";

export const useAmazonSales = (
  isbns: string[] | undefined,
  initialGranularity?: Granularity,
) => useSalesQuery<AmazonSalesResponse>(isbns, "amazon", initialGranularity);
